import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "user-avatar" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "user-info" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", { onClick: $setup.handleShowMovieList }, "🎬"),
      ($props.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "user",
            onClick: $setup.toggleUserMenu,
            tabindex: "0"
          }, [
            _createElementVNode("div", _hoisted_3, [
              ($props.user?.picture)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $props.user.picture,
                    alt: $props.user.name
                  }, null, 8 /* PROPS */, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($props.user?.name?.charAt(0) || '👤'), 1 /* TEXT */))
            ]),
            ($setup.userMenuOpen)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "user-menu",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("strong", null, _toDisplayString($props.user?.name), 1 /* TEXT */),
                    _createElementVNode("small", null, _toDisplayString($props.user?.email), 1 /* TEXT */)
                  ]),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _cache[2] || (_cache[2] = _createTextVNode("Top up")),
                        _createElementVNode("small", null, _toDisplayString($props.user?.credits || 0) + " Credits", 1 /* TEXT */)
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _withModifiers($setup.handleSettings, ["prevent"])
                      }, "Settings")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _withModifiers($setup.handleLogout, ["prevent"])
                      }, "Logout")
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode($setup["SettingsModal"], {
      user: $props.user,
      "is-open": $setup.settingsModalOpen,
      onClose: $setup.handleCloseSettings,
      onUserUpdated: $setup.handleUserUpdated
    }, null, 8 /* PROPS */, ["user", "is-open"])
  ]))
}